import { memoizr }                            from '../../../reduxion-core/lib'
import * as transform                         from '../../lib/transform'
import actionTypes                            from '../../constants/actionTypes'
import { getFlexApiUrl }      from './index'

/**
 * [getClubhouse Get clubhouse API]
 * @param  {Object} edition  [edition details]
 * @param  {Object} params   [page params]
 * @param  {Object} location [location details]
 * @return {[type]}          [redux action]
 */
export default function getClubhouse({ edition = {}, params = {}, location = {} }) {
  let additionalQuery = {
    team: params.team,
    sport: params.sport,
    pubkey: `${params.sport}-clubhouse`
  }

  if(params.sport === 'rugby') {
    additionalQuery.pubkey = 'rugby-team-clubhouse'
  }

  let url = getFlexApiUrl(edition, params, location, additionalQuery)

  return {
    url,
    edition,
    params,
    location,
    promise: memoizr.get(url),
    type: actionTypes.GET_CLUBHOUSE,
    transform: transform.onGetClubhouse
  }
}



// WEBPACK FOOTER //
// ../app/actions/api/clubhouse.js